import {Catalogo} from "../catalogo/Catalogo";
import {CategoriaNaEmpresa} from "../catalogo/CategoriaNaEmpresa";
import {AreaDestino} from "../kds/AreaDestino";

export class Categoria {
  constructor(public id: number, public nome: string,
              public catalogo: Catalogo,
              public impressoras: Array<any> = [],
              public codigoPdv: string = null ,
              public nivel: number = 1) {

  }

  static Outros: any =  {
    id: -1,
    nome: 'Outros',
    disponivel: true,
    posicao: 1000
  };
  posicao: number;
  disponivel: boolean;
  codigoIfood: string;
  categoriaPai: any;
  categoriaOriginal: any;
  categoriaNaEmpresa: CategoriaNaEmpresa
  sincronizarModelo = false;
  imagem: string;
  /**
   * Desenho da prateleira desta categoria na loja: 'lista', 'grade', 'vitrine'
   * ou 'linha'. Nulo = a loja escolhe pelo conteúdo (fotos, tamanho do texto e
   * alternância com a prateleira vizinha).
   */
  formatoVitrine: string = null;

  public areasDestino: Array<AreaDestino>  = [];
  ehIgual(categoria: any) {
    if(!categoria) return false;

    let mesmoCodigo = this.codigoPdv != null && categoria.codigoPdv != null ?   this.codigoPdv ===  categoria.codigoPdv : false;

    if(mesmoCodigo) return  true;

    let mesmoNome = categoria.nome && this.nome  ?
      (categoria.nome.toUpperCase() ===  this.nome.toUpperCase()) :  categoria.nome === this.nome;

    return mesmoNome
  }

}
